<template>
    <div class="drawer-sections">
        <div>
            <div class="dr-sec-h">Распределение услуг</div>
            <p class="dr-sec-p">
                Отметьте дополнительные услуги — мастер будет предлагать их клиенту во время визита.
            </p>
            <div class="m15-svc">
                <StarterPackLoader
                    v-if="servicesLoading"
                    compact
                    label="Загружаем услуги..."
                />
                <template v-else-if="serviceList.length">
                    <label
                        v-for="service in serviceList"
                        :key="service.id"
                        :class="[
                            'm15-row',
                            { on: (scenario.settings.additionalServiceIds || []).includes(service.id) },
                        ]"
                    >
                        <span class="m15-cb"></span>
                        <input
                            v-model="scenario.settings.additionalServiceIds"
                            type="checkbox"
                            :value="service.id"
                        />
                        <span class="m15-tx">
                            <span class="m15-n">{{ service.name }}</span>
                            <span class="m15-c">{{ service.category }}</span>
                        </span>
                    </label>
                </template>
                <div v-else class="m15-empty">Услуги не найдены</div>
            </div>
        </div>
        <div class="dr-divider"></div>
        <div>
            <div class="dr-sec-h">Текст сообщения мастеру</div>
            <textarea v-model="scenario.settings.scriptText" class="script"></textarea>
            <div class="panel-vars">
                <button
                    v-for="variable in scenario.meta.vars"
                    :key="variable"
                    class="var"
                    @click="scenario.settings.scriptText += variable"
                >
                    {{ variable }}
                </button>
            </div>
        </div>
        <div class="dr-divider"></div>
        <label class="dr-enable">
            <span class="dr-enable-tx">
                <span class="dr-enable-l">Включить сценарий</span>
                <span class="dr-enable-s">Сообщение уходит мастеру за 15 минут до визита</span>
            </span>
            <button
                :class="['dr-sw', { on: scenario.settings.enabled }]"
                type="button"
                @click="scenario.settings.enabled = !scenario.settings.enabled"
            ></button>
        </label>
    </div>
</template>

<script>
import StarterPackLoader from '../StarterPackLoader.vue'

export default {
    name: 'StarterPackDrawerMaster15',
    components: { StarterPackLoader },
    props: {
        scenario: {
            type: Object,
            required: true,
        },
        serviceList: {
            type: Array,
            default: () => [],
        },
        servicesLoading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.dr-sec-h {
    margin-bottom: 8px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13.5px;
    font-weight: 800;
    letter-spacing: -0.01em;
}

.dr-sec-p {
    margin-bottom: 14px;
    color: $muted-new;
    font-size: 12.5px;
    line-height: 1.5;
}

.dr-divider {
    height: 1px;
    background: $border-new;
    margin: 0;
}

.drawer-sections {
    display: flex;
    flex-direction: column;
    gap: 22px;
}

.m15-svc {
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-height: 120px;
    max-height: 210px;
    overflow-y: auto;
}

.m15-empty {
    padding: 6px 2px;
    color: $muted-light-new;
    font-size: 12px;
    line-height: 1.45;
}

.m15-row {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 10px 12px;
    background: #fff;
    border: 1px solid $border-new;
    border-radius: 10px;
    cursor: pointer;
}

.m15-row input {
    display: none;
}

.m15-row.on {
    background: $bcg-card-new;
    border-color: $main-new;
}

.m15-cb {
    position: relative;
    flex-shrink: 0;
    width: 19px;
    height: 19px;
    border: 2px solid #c7cdda;
    border-radius: 6px;
}

.m15-row.on .m15-cb {
    background: $main-new;
    border-color: $main-new;
}

.m15-row.on .m15-cb::after {
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    content: '';
    transform: rotate(45deg);
}

.m15-tx {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 1px;
}

.m15-n {
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13px;
    font-weight: 700;
}

.m15-c {
    color: $muted-new;
    font-size: 11px;
}

.script {
    width: 100%;
    min-height: 96px;
    padding: 12px 14px;
    color: $text-color-new;
    font-family: Inter, system-ui, sans-serif;
    font-size: 13px;
    line-height: 1.55;
    resize: vertical;
    background: #fff;
    border: 1px solid $border-new;
    border-radius: 10px;
    outline: none;
}

.panel-vars {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
}

.var {
    padding: 3px 8px;
    color: $main-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 11px;
    font-weight: 600;
    background: $bcg-card-new;
    border: 0;
    border-radius: 6px;
    cursor: pointer;
}

.dr-enable {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    cursor: pointer;
}

.dr-enable-tx {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.dr-enable-l {
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13.5px;
    font-weight: 800;
}

.dr-enable-s {
    color: $muted-new;
    font-size: 11.5px;
}

.dr-sw {
    position: relative;
    flex-shrink: 0;
    width: 44px;
    height: 25px;
    cursor: pointer;
    background: #d2d7e0;
    border: 0;
    border-radius: 999px;
}

.dr-sw.on {
    background: $success-new;
}

.dr-sw::after {
    position: absolute;
    top: 2.5px;
    left: 2.5px;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    content: '';
    transition: left 0.18s, transform 0.18s;
}

.dr-sw.on::after {
    transform: translateX(19px);
}
</style>
